<template>
    <div>
        <div class="row">
            <div class="col-md-12 ">
                <div class="panel panel-default">
                    <div class="panel-heading">
                      Extent History <timezone v-if="timezone_meta" :current_timezone="timezone_meta.nice_timezone"></timezone>
                    </div>

                    <div class="panel-body">
                      <div v-if="running && running.length>0" style="background:lightgreen;margin-top:10px;padding:10px;width:100%;margin-bottom:30px;text-color:black;">
                        <div><p><strong>Currently running jobs for this extent (regardless of who initiated):</strong></p></div>
                        <ul>
                          <li v-for="chain in running"><a :href="chain.clean.progress_url">{{chain.clean.description}} on {{chain.clean.extent_name}}, initiated by {{chain.clean.user}} {{chain.clean.created}}</a></li>
                        </ul>
                        <div><em>Note: this information is updated every five minutes by the system, and you must refresh this page to see updates.</em></div>

                      </div>
                      <div v-else-if="table_data" style="background:lightgray;margin-top:10px;padding:10px;width:100%;margin-bottom:30px;text-color:black;">
                        There are no jobs running for this extent.
                      </div>
                      <activity-list :table_data="table_data"></activity-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['extent_id_from_blade'],
        mounted() {
            axios.get("/api/extents/history/" + this.extent_id_from_blade)
                .then(response => {
                    console.log(response.data)
                    this.table_data = response.data.events
                    this.timezone_meta = response.data.meta
                    this.running = response.data.running
                })
                .catch(error => {
                    console.log("Could not get history for extent " + this.extent_id_from_blade)
                })
        },
        data() {
            return {
                selected_extent_id: null,
                table_data: null,
                timezone_meta: null,
                columns: [
                    {prop: "description", label:"Description"},
                ]
            }
        }
    }
</script>